import { IActivatedPriceListData } from "common/records/ActivatedPriceList";
import { fetcher } from "common/api/Fetcher";
import { ActivatedPriceListParamsRecord } from "common/records/index/ActivatedPriceListParams";
import { toParams } from "common/records/index/QueryParamsBase";
import { IMetaPaginationData } from "common/records/MetaPagination";

export interface ActivatedPriceListIndexResponse {
  activated_price_lists: IActivatedPriceListData[];
  meta?: { pagination: Partial<IMetaPaginationData> };
}

export interface ActivatedPriceListResponse {
  activated_price_list: IActivatedPriceListData;
}

const url = "api/v1/orgs/:org_id/activated_price_lists";

export const list = (queryParams: ActivatedPriceListParamsRecord): Promise<ActivatedPriceListIndexResponse> => {
  const actionUrl = fetcher.joinUrls(url.replace(":org_id", queryParams.orgId.toString()));
  const parameters = toParams(queryParams);
  delete parameters.orgId;

  return fetcher.get(actionUrl, parameters);
};

export const getCached = async (orgId: number, priceListId: number): Promise<ActivatedPriceListResponse> => {
  const actionUrl = fetcher.joinUrls(
    fetcher.joinUrls(url.replace(":org_id", orgId.toString()), priceListId.toString(), "cached"),
  );
  return fetcher.get(actionUrl);
};
